var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"networking-widget-v2",attrs:{"id":"networking-widget-v2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }